import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [monEspaceOpen, setMonEspaceOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setMonEspaceOpen(false);
  };
  const isActive = (path: string) => location.pathname === path;
  const toggleMonEspace = () => setMonEspaceOpen(!monEspaceOpen);

  return (
    <header className="fixed w-full z-50 bg-background/90 backdrop-blur-sm shadow-sm">
      <div className="container mx-auto flex items-center justify-between h-16 px-4">
        <Link to="/" className="text-primary font-serif">
          <h1 className="font-bold text-xl tracking-widest">MENEORA</h1>
          <p className="text-[0.6rem] tracking-widest text-foreground/80">MENER À L'OR</p>
        </Link>
        
        <nav className="hidden md:flex space-x-8 text-foreground/80">
          <a href="/#home" className="hover:text-primary transition-colors">Accueil</a>
          <a href="/#je-suis-meredith-meneora" className="hover:text-primary transition-colors">À propos</a>
          
          <div className="relative group">
            <button 
              className="hover:text-primary transition-colors flex items-center"
              onMouseEnter={() => setMonEspaceOpen(true)}
              onMouseLeave={() => setMonEspaceOpen(false)}
            >
              Mon espace
              <ChevronDown className="ml-1 h-4 w-4" />
            </button>
            <div 
              className={`absolute top-full left-0 mt-2 w-72 bg-background border border-secondary/20 rounded-md shadow-lg transition-all duration-200 ${monEspaceOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
              onMouseEnter={() => setMonEspaceOpen(true)}
              onMouseLeave={() => setMonEspaceOpen(false)}
            >
              <Link 
                to="/particulier" 
                className="block px-4 py-3 text-sm hover:bg-accent/20 hover:text-primary transition-colors border-b border-secondary/10"
              >
                Mon accompagnement sur mesure
              </Link>
              <Link 
                to="/professionnel" 
                className="block px-4 py-3 text-sm hover:bg-accent/20 hover:text-primary transition-colors"
              >
                Mon accompagnement en profondeur
              </Link>
            </div>
          </div>
          
          <a href="/#contact" className={`hover:text-primary transition-colors ${isActive('#contact') ? 'text-primary' : ''}`}>Contact</a>
          <Link to="/blog" className={`hover:text-primary transition-colors ${isActive('/blog') ? 'text-primary' : ''}`}>Blog</Link>
          <Link to="/boutique" className={`hover:text-primary transition-colors ${isActive('/boutique') ? 'text-primary' : ''}`}>Boutique</Link>
        </nav>

        <div className="md:hidden">
          <Button variant="ghost" size="icon" onClick={toggleMobileMenu}>
            <Menu className="h-6 w-6" />
          </Button>
        </div>
      </div>
      
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-16 inset-x-0 bg-background shadow-md p-4">
          <div className="flex flex-col space-y-4">
            <a href="/#home" className="text-foreground/80 hover:text-primary transition-colors py-2" onClick={closeMobileMenu}>Accueil</a>
            <a href="/#je-suis-meredith-meneora" className="text-foreground/80 hover:text-primary transition-colors py-2" onClick={closeMobileMenu}>À propos</a>
            
            <div>
              <button 
                onClick={toggleMonEspace}
                className="text-foreground/80 hover:text-primary transition-colors py-2 flex items-center w-full text-left"
              >
                Mon espace
                <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              {monEspaceOpen && (
                <div className="ml-4 mt-2 space-y-2">
                  <Link to="/particulier" className="block text-foreground/70 hover:text-primary transition-colors py-2" onClick={closeMobileMenu}>
                    Mon accompagnement sur mesure
                  </Link>
                  <Link to="/professionnel" className="block text-foreground/70 hover:text-primary transition-colors py-2" onClick={closeMobileMenu}>
                    Mon accompagnement en profondeur
                  </Link>
                </div>
              )}
            </div>
            
            <a href="/#contact" className="text-foreground/80 hover:text-primary transition-colors py-2" onClick={closeMobileMenu}>Contact</a>
            <Link to="/blog" className="text-foreground/80 hover:text-primary transition-colors py-2" onClick={closeMobileMenu}>Blog</Link>
            <Link to="/boutique" className="text-foreground/80 hover:text-primary transition-colors py-2" onClick={closeMobileMenu}>Boutique</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
